export default "__VITE_ASSET__7bebbdf8__"